import { render, staticRenderFns } from "./TypePlanning.vue?vue&type=template&id=488d2176&"
import script from "./TypePlanning.vue?vue&type=script&lang=ts&"
export * from "./TypePlanning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports